import React from 'react';
import { IconButton, Table, TableBody, TableCell, TableHead, TableRow, Tooltip } from '@material-ui/core';
import { API_URL } from '../../constants/api';
import CancelIcon from '@material-ui/icons/Cancel';
import EditIcon from '@material-ui/icons/Edit';
import { apiBatchRequest, apiPost, apiPut, apiRequest } from '../../utils/api_service';
import SaveIcon from '@material-ui/icons/Save';
import { ShowToast, toastType } from '../../utils/toast-service';
import { isGridFormValid, IsSectionVisible, UpdateColumnWithConfiguration } from '../../utils/helper';
import GridTable from '../common/Table/Table';
import { SECTIONS } from '../../constants/appConstants';
import { employeeTitlesMappingColumnList } from '../../constants/MockData';
import _, { cloneDeep } from 'lodash';

// Component to Configure Employee Titles
class ConfigureEmployeeTitle extends React.Component {
  // Constructor to set initial state
  constructor (props) {
    super(props);
      this.state = {
        designationMasterData: [],
        configuration: [],
        isInAddMode: false,
        selectedEditRowId: undefined,
        updateData: {
          designationID: 0,
          designation: null
        },
        employeeTitlesMappingColumn: cloneDeep(employeeTitlesMappingColumnList)
      };
  }

  // Method executes before components are rendered, to get all required data from database
  componentDidMount () {
    this.getRequiredData();      
  }

  // Get Employee Title master data
  getRequiredData = () => {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Employee.GetDesignationConfiguration,
        key: 'designationMasterData'
      }
    ])
      .then(({ designationMasterData}) => {
        this._asyncRequest = null;
        if (designationMasterData.success !== true) {
          ShowToast('Something went wrong', toastType.ERROR, 5000, 500, 'Server error');
        }
        
        this.setState({
          designationMasterData: designationMasterData.data || [],
          configuration: designationMasterData.config || []
        });
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  // Get employee titles data
  GetEmployeeTitleData = () => {
    apiRequest({
      url: API_URL.Employee.GetDesignationConfiguration
    }).then(({ data: response }) => {
      this.setState({
        designationMasterData: response || []
      });
    });
  };

  // Cancel add/edit mode
  cancelMode = () => {
    this.setState({ selectedEditRowId: undefined, isInAddMode: false, updateData: undefined });
    this.GetEmployeeTitleData();
  };

  // Check Validation on Form fields
  isValidForm = () => {
    let IsValid = true;
    const { updateData, employeeTitlesMappingColumn } = this.state;
    employeeTitlesMappingColumn.forEach((ele) => {
      isGridFormValid(updateData[ele.key], ele, updateData);
      if (ele.isInErrorState === true) {
        IsValid = false;
      }
    });
    this.setState({ employeeTitlesMappingColumn }, this.forceUpdate());
    return IsValid;
  };

  // Add/Update Employee Title configuration
  saveUpdatedRecord = () => {
    if (!this.isValidForm()) { return false; }
    const newParam = this.state.updateData;
    const params = {
      designationID: newParam.designationID,
      isMappingRequired: newParam.isMappingRequired
    };

    apiPost({
      url: API_URL.Employee.UpdateDesignationConfiguration,
      params: {},
      postBody: params
    }).then(({ data: response }) => {
      if (response.success === true) {
        ShowToast(this.state.isInAddMode ? 'Record added successfully.' : 'Record updated successfully.', toastType.SUCCESS, 5000, 500);
        this.setState({
          updateData: undefined,
          selectedEditRowId: undefined
        });
        this.GetEmployeeTitleData();
      } else {
        ShowToast(response.message, toastType.ERROR, 5000, 500);
      }
    });
  };

  // Edit selected record
  EditRecord = (cellInfo) => {
    this.setState({ selectedEditRowId: { key: 'designationID', value: cellInfo.designationID }, isInAddMode: false, updateData: { ...cellInfo }, employeeTitlesMappingColumn: _.cloneDeep(employeeTitlesMappingColumnList) });
  }

  // Render Edit/Update action columns on each records based on conditions
  renderActionColumn = (cellInfo) => {
    return (
      <>
        {this.state.selectedEditRowId !== undefined && cellInfo.designationID === this.state.selectedEditRowId.value
          ? (
            <>
              <Tooltip title="Save Record">
                <IconButton aria-label={'refreshData'} size="small" onClick={() => { }}>
                  <SaveIcon fontSize="small" size="small" onClick={this.saveUpdatedRecord} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Cancel">
                <IconButton aria-label={'refreshData'} size="small" onClick={this.cancelMode}>
                  <CancelIcon fontSize="small" size="small" />
                </IconButton>
              </Tooltip>
            </>
            )
          : (IsSectionVisible(SECTIONS.CONFIGURATION, SECTIONS.CONFIGURE_EMPLOYEE_TITLE, SECTIONS.ADD_EDIT)) && (
            <Tooltip title="Edit Record">
              <IconButton
                aria-label={'refreshData'}
                size="small"
                onClick={() => {
                  this.EditRecord(cellInfo);
                }}
              >
                <EditIcon fontSize="small" size="small" />
              </IconButton>
            </Tooltip>
            )}
      </>
    );
  };

  // Handle edit event of row
  handleTableEditChange = (value, fieldName, row, addMode) => {
    const { employeeTitlesMappingColumn } = this.state;
    const param = { ...this.state.updateData };
    param[fieldName] = value;

    isGridFormValid(value, employeeTitlesMappingColumn.find(x => x.key === fieldName), param);
    this.setState({ updateData: param, reloadTable: !this.state.reloadTable });
  };

  // Add new record of Expense Group and Pay codes mapping
  AddNewRecord = () => {
    if (this.state.isInAddMode === true) {
      ShowToast('You can add one row at a time!', toastType.WARNING, 5000, 500);
      return false;
    }

    // Object of new record
    const rowNew = {
      designationID: 0,
      designation: null
      // isMappingRequired: false
    };
    this.setState({ isInAddMode: true, selectedEditRowId: { key: 'designationID', value: 0 }, updateData: rowNew });
  };

  // Render components based on conditions
  render () {
    const { employeeTitlesMappingColumn, designationMasterData } = this.state;
    const EditSource = [];
    return (
      <>
        <Table
          aria-labelledby="tableMenuTitle"
          size={'small'}
          aria-label="configuration table"
        >
          <TableHead>
            <TableRow>
              <TableCell
                key={'configureHeader'}
                className="content-header"
                colSpan={2}
              >
                <div className="content-header d-flex">
                  {' '}
                  <div
                    className="col-xs-11"
                    style={{ display: 'inline-block', alignItems: 'center' }}
                  >
                    Employee Title Configuration
                  </div>
                </div>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>
                <GridTable
                  columns={UpdateColumnWithConfiguration(employeeTitlesMappingColumn, this.state.configuration, [])}
                  // columns={employeeTitlesMappingColumn}
                  data={designationMasterData}
                  config={employeeTitlesMappingColumn}
                  renderActionColumn={this.renderActionColumn}
                  selectedEditRowId={this.state.selectedEditRowId}
                  isInAddMode={this.state.isInAddMode}
                  EditSource={EditSource}
                  handleTableEditChange={this.handleTableEditChange}
                  updateData={this.state.updateData}
                  reload={this.state.reloadTable}
                  isInline={true}
                ></GridTable>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </>
    );
  };
}

export default ConfigureEmployeeTitle;